import { render, staticRenderFns } from "./AddEditProjectModal.vue?vue&type=template&id=306f1717"
import script from "./AddEditProjectModal.vue?vue&type=script&lang=js"
export * from "./AddEditProjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports